<template>
  <div class="prescription-preview">
    <div class="prescription-preview__body">
      <iframe
        ref="prescriptionPreviewFrame"
        width="100%"
        :height="height"
        :src="prescriptionFrameUrl"
        frameborder="0" />
    </div>
    <div class="prescription-preview__footer">
      <div class="btn-group" role="group">
        <button
          v-if="showPrint"
          :disabled="loadingPrescription"
          class="btn btn-sm btn-primary"
          type="button"
          @click="printPrescription">
          <i class="fas fa-print" /> Imprimir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrescriptionPreview',
  props: {
    prescriptionId: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '450px'
    },
    showPrint: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingPrescription: true,
      prescriptionFrameUrl: ''
    };
  },
  created() {
    this.loadData();
  },
  /*
  computed: {

    prescriptionFrameUrl() {
      return `${process.env.VUE_APP_API_URL}/medication-request/${this.prescriptionId.replace(/-/g, '')}/preview`;
    }
  }, */
  methods: {
    loadData() {
      this.$store.dispatch('previewMedicationRequest', this.prescriptionId)
        .then(response => {
          let blob = new Blob([response.data], { type: 'text/html' });
          this.prescriptionFrameUrl = window.URL.createObjectURL(blob);
          this.$emit('prescription-loaded');
          this.loadingPrescription = false;
        });
    },
    async handleFrameLoaded() {
      this.$emit('prescription-loaded');
      this.loadingPrescription = false;
    },
    printPrescription() {
      this.$refs.prescriptionPreviewFrame.focus();
      this.$refs.prescriptionPreviewFrame.contentWindow.print();
    }
  }
};
</script>

<style lang="scss">
.prescription-preview {
  display: flex;
  flex-direction: column;

  &__body {
    height: 100%;
    margin-bottom: 1rem;
  }
}
</style>
